import { FunctionalComponent, h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

type Props = {
  hasMore: boolean;
  loading: boolean;
  failed: boolean;
  loaded: number;
  total: number;
  onLoad: () => void;
  endText: string;
};

/** Keep the next-page trigger separate from the list's request and stale-response guards. */
const ScrollLoader: FunctionalComponent<Props> = ({ hasMore, loading, failed, loaded, total, onLoad, endText }) => {
  const sentinel = useRef<HTMLDivElement>(null);
  const load = useRef(onLoad);
  load.current = onLoad;

  useEffect(() => {
    if (!hasMore || loading || failed || !sentinel.current) return;
    let active = true;
    let triggered = false;
    const observer = new IntersectionObserver((entries) => {
      if (!active || triggered || !entries.some((entry) => entry.isIntersecting)) return;
      triggered = true;
      load.current();
    }, { rootMargin: '0px 0px 160px 0px' });
    observer.observe(sentinel.current);
    return () => { active = false; observer.disconnect(); };
  }, [hasMore, loading, failed, loaded]);

  return (
    <div ref={sentinel} class="vp-scroll-loader">
      {failed ? (
        <button type="button" class="vp-loadmore failed" onClick={onLoad}>加载失败，点击重试</button>
      ) : (
        <div class="vp-list-end" role="status" aria-live="polite" aria-busy={loading}>
          {loading ? '正在加载…' : hasMore ? `已加载 ${loaded}/${total} 件` : endText}
        </div>
      )}
    </div>
  );
};

export default ScrollLoader;
